import { render, staticRenderFns } from "./addLibrosObsequios.vue?vue&type=template&id=afb4270c"
import script from "./addLibrosObsequios.vue?vue&type=script&lang=js"
export * from "./addLibrosObsequios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports